import axios from 'axios'
import router from '@/router'

const instance = axios.create({
    baseURL: 'https://integrator.wrealizacji.pl/api.php'
})

// Pomocnicza funkcja sprawdzająca, czy zapytanie dotyczy logowania
const isLoginAction = (configData) => {
    try {
        const parsed = typeof configData === 'string' ? JSON.parse(configData) : configData
        return parsed?.action === 'login'
    } catch {
        return false
    }
}

// 1. Interceptor zapytania (dołączanie tokena tylko gdy jest i gdy to nie logowanie)
instance.interceptors.request.use((config) => {
    const token = localStorage.getItem('integrator_token')
    
    if (token && !isLoginAction(config.data)) {
        config.headers.Authorization = `Bearer ${token}`
    }
    
    return config
})

// 2. Interceptor odpowiedzi (weryfikacja roli / sesji)
instance.interceptors.response.use(
    (response) => {
        const isLogin = isLoginAction(response.config?.data)

        // Jeśli to NIE JEST logowanie, a serwer nie zwrócił roli -> wyloguj i przekieruj
        if (!isLogin && !response.data?.role) {
            localStorage.removeItem('integrator_token')
            localStorage.removeItem('user_email')
            localStorage.removeItem('user_role')
            localStorage.removeItem('admin_email')
            
            router.push('/admin/login')
        } else if (response.data?.role) {
            localStorage.setItem('user_role', response.data.role)
        }

        return response
    },
    (error) => {
        const isLogin = isLoginAction(error.config?.data)

        // Nie przekierowuj na login, jeśli błąd 401 wystąpił podczas samego logowania
        if (error.response?.status === 401 && !isLogin) {
            localStorage.removeItem('integrator_token')
            localStorage.removeItem('user_email')
            localStorage.removeItem('user_role')
            localStorage.removeItem('admin_email')
            router.push('/admin/login')
        }
        return Promise.reject(error)
    }
)

// Przeciążenie metody post
const apiClient = {
    ...instance,
    post(data, config) {
        return instance.post('', data, config)
    }
}

export default apiClient